export const calculateBounds = (longitude, latitude, zoom) => {
  const delta = 600 / Math.pow(2, zoom);

  return {
    minLng: longitude - delta,
    maxLng: longitude + delta,
    minLat: latitude - delta,
    maxLat: latitude + delta,
  };
};

export const isWithinBounds = (item, bounds) => {
  return (
    item.lng >= bounds.minLng &&
    item.lng <= bounds.maxLng &&
    item.lat >= bounds.minLat &&
    item.lat <= bounds.maxLat
  );
};
